var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"no-close-on-backdrop":"","centered":"","hide-footer":"","title":_vm.pricing.id ? 'Edit pricing' : 'New pricing',"modal-class":_vm.theme}},[_c('PricingEdit',{attrs:{"pricing":_vm.pricing,"error":_vm.errorMsg,"loading":_vm.loading},on:{"request-save":_vm.onRequestSave,"close":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }